// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2LVvx","smallLinkTypography":"_1omMc","titleTypography":"jBUTZ","cardTitleTypography":"_1Msy2","truncate":"_2VRIi","base":"_1OtNk","noRecord":"_3BTEd"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerReports/PartnerPlan/components/PartnerPlanStatusTable.scss
// module id = 2697
// module chunks = 0